module.exports = __webpack_public_path__ + "static/case_study_bananki_front-f1c6b404918709f58b6f5b3350850e6c.png";